// =============================================================================
// Wurzelwelt — Discount Code Badge (Copy to Clipboard)
// =============================================================================
// Update-sicher: Diese Datei wird vom Savor Theme niemals überschrieben.
// Voraussetzung: snippets/wurzelwelt-discount-badge.liquid wird gerendert.
// Aktivierung: Section bindet diese Datei via <script src=...> ein.
// =============================================================================

const FEEDBACK_DURATION_MS = 2500;
const COPY_SELECTOR = '[data-wurzelwelt-copy-code]';

const CHECKMARK_SVG = `<svg class="wurzelwelt-badge__icon wurzelwelt-badge__icon--check" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }
  return legacyCopy(text);
}

function legacyCopy(text) {
  return new Promise((resolve, reject) => {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.setAttribute('aria-hidden', 'true');
    ta.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
    document.body.appendChild(ta);

    if (/ipad|iphone/i.test(navigator.userAgent)) {
      const range = document.createRange();
      range.selectNodeContents(ta);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      ta.setSelectionRange(0, 999999);
    } else {
      ta.select();
    }

    try {
      document.execCommand('copy')
        ? resolve()
        : reject(new Error('execCommand returned false'));
    } catch (err) {
      reject(err);
    } finally {
      document.body.removeChild(ta);
    }
  });
}

async function handleCopy(button) {
  // Lock gegen Doppel-Klick während laufender Animation
  if (button.dataset.copying === 'true') return;
  button.dataset.copying = 'true';

  const code = button.dataset.code;
  if (!code) {
    console.warn('[wurzelwelt-discount-badge] data-code Attribut fehlt', button);
    delete button.dataset.copying;
    return;
  }

  try {
    await copyToClipboard(code);
    showFeedback(button, 'success');
  } catch (err) {
    console.error('[wurzelwelt-discount-badge] Copy fehlgeschlagen:', err);
    showFeedback(button, 'error');
  }
}

function showFeedback(button, state) {
  const badgeCode = button.querySelector('.wurzelwelt-badge__code');
  const badgeIcon = button.querySelector('.wurzelwelt-badge__icon');
  if (!badgeCode || !badgeIcon) return;

  // Original einmalig sichern (überlebt schnelle Re-Trigger)
  if (!button.dataset.originalCode) {
    button.dataset.originalCode = badgeCode.textContent;
    button.dataset.originalIcon = badgeIcon.outerHTML;
  }

  if (state === 'success') {
    badgeCode.textContent = 'KOPIERT';
    badgeIcon.outerHTML = CHECKMARK_SVG;
    button.classList.add('is-copied', 'is-success');
    button.setAttribute('aria-label', 'Code in Zwischenablage kopiert');
  } else {
    badgeCode.textContent = 'FEHLER';
    button.classList.add('is-error');
    button.setAttribute('aria-label', 'Kopieren fehlgeschlagen');
  }

  setTimeout(() => resetButton(button), FEEDBACK_DURATION_MS);
}

function resetButton(button) {
  const badgeCode = button.querySelector('.wurzelwelt-badge__code');
  const currentIcon = button.querySelector('.wurzelwelt-badge__icon');

  if (badgeCode && button.dataset.originalCode) {
    badgeCode.textContent = button.dataset.originalCode;
  }
  if (currentIcon && button.dataset.originalIcon) {
    currentIcon.outerHTML = button.dataset.originalIcon;
  }

  button.classList.remove('is-copied', 'is-success', 'is-error');
  button.removeAttribute('aria-label');

  delete button.dataset.copying;
  delete button.dataset.originalCode;
  delete button.dataset.originalIcon;
}

// Event-Delegation: funktioniert auch nach Section-Re-Render im Theme Editor
document.addEventListener('click', (event) => {
  const button = event.target.closest(COPY_SELECTOR);
  if (button) handleCopy(button);
});

// Tastatur-Support
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const button = event.target.closest(COPY_SELECTOR);
  if (button) {
    event.preventDefault();
    handleCopy(button);
  }
});